import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import subExpired from "../../assets/svg/sub-expired.svg";

let isModalVisible = false;

const useUpgradeAlert = (callback) => {
  const navigate = useNavigate();

  const showUpgradeAlert = (featureName = "this feature") => {
    if (isModalVisible) return;

    isModalVisible = true;

    Modal.warning({
      icon: null,
      title: null,
      footer: null,
      closable: true,
      width: 650,
      className: "no-padding-modal",
      content: (
        <div
          className="login-card d-flex flex-column align-items-center"
          style={{
            backgroundImage: "url('/sub-expired-bg.svg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            maxWidth: 750,
            padding: 20,
            borderRadius: 8,
          }}
        >
          <img src={subExpired} alt="Subscription Expired" />
          <div
            style={{ marginTop: "-30px" }}
            className="heading24px text-color-072D81 fw-semibold text-center"
          >
            It’s Time for Your Upgrade!
          </div>

          <div className="heading14px text-color-414141 text-center mt-2">
            This feature isn’t included in your current plan. Upgrade now to
            unlock full access.
          </div>

          <div
            className="text-color-072D81 update-now-btn fw-semibold cursor-pointer bg-white p5px rounded-pill mt20"
            onClick={() => {
              isModalVisible = false;
              Modal.destroyAll();
              navigate("/pricing");
              callback?.();
            }}
          >
            UPDATE NOW
          </div>
          <div className="mt10 heading13px text-color-414141 text-center">
            Unlock premium features instantly after upgrade!
          </div>
          <div
            style={{ width: "100%" }}
            className="mt30 d-flex heading13px justify-content-end align-items-center"
          >
            Need help?{" "}
            <a
              href="mailto:contact@beyondleadz.ai"
              style={{ color: "#5D44FF" }}
              className="heading13px"
            >
              &nbsp; contact@beyondleadz.ai
            </a>
          </div>
        </div>
      ),
      onCancel: () => {
        isModalVisible = false;
        callback?.();
      },
      afterClose: () => {
        isModalVisible = false;
      },
    });
  };

  return showUpgradeAlert;
};

export default useUpgradeAlert;
